"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Hooks = __importStar(require("@apollo/react-hooks"));
var ApolloDefender_1 = require("../ApolloDefender");
var useLoadingStash_1 = require("./useLoadingStash");
function useQuery(query, variables, options) {
    var result = Hooks.useQuery(query, __assign({ variables: variables, fetchPolicy: 'cache-and-network' }, options));
    ApolloDefender_1.useApolloDefenderReporter(result.error, query, variables);
    var getStash = useLoadingStash_1.useLoadingStash(result.loading, result.data);
    return __assign(__assign({}, result), { 
        /**
         * Wrapper around `useLoadingStash` to obtain previous result
         * while next one is loading.
         *
         * Can yield `null` initially before first result is fetched.
         *
         * The `skip` argument is taken directly from options and doesn't
         * need to be checked.
         *
         * Can be called multiple times with different resolvers.
         *
         * @param resolver
         */
        getStash: function (resolver) {
            return getStash(resolver, options && options.skip);
        },
        get hasData() {
            return this.data !== undefined;
        },
        get hasError() {
            return this.error !== undefined;
        } });
}
exports.useQuery = useQuery;
//# sourceMappingURL=useQuery.js.map